import 'src/global.css';

import { useEffect } from 'react';

import { usePathname } from 'src/routes/hooks';

import { toast, Snackbar } from 'src/components/snackbar';
import { ProgressBar } from 'src/components/progress-bar';
import { SettingsDrawer, defaultSettings } from 'src/components/settings';

import { useAppDispatch } from './hooks';
import { getAllProducts } from './data/api';
import { setAllProducts } from './features/productSlice/productSlice';

type AppProps = {
  children: React.ReactNode;
};

export default function App({ children }: AppProps) {
  useScrollToTop();
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchEverything();
  }, []);

  const fetchEverything = async () => {
    try {
      const products = await getAllProducts();
      dispatch(setAllProducts(products));
    } catch (error) {
      toast.error('Kunne ikke hente data');
      console.error(error);
    }
  };

  return (
    <>
      <Snackbar />
      <ProgressBar />
      <SettingsDrawer defaultSettings={defaultSettings} />
      {children}
    </>
  );
}

function useScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
